'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { ShowMoreContent } from '@/src/components/features/property/ui/ShowMoreContent';
import { sanitizeLegalDisclaimer } from './legalInfoModule.utils';
import * as styles from './legalInfoModule.styles';

type Props = {
  listing: PropertyDetailListing;
};

export const LegalInfoModule = ({ listing }: Props) => {
  const t = useTranslations('hdp');
  const paragraphs = useMemo(() => sanitizeLegalDisclaimer(listing.legalDisclaimer), [listing.legalDisclaimer]);

  if (paragraphs.length === 0) {
    return null;
  }

  return (
    <ShowMoreContent
      controlsId="legal-info-module-details"
      showMoreLabel={t('showMore')}
      showLessLabel={t('showLess')}
      showMoreAriaLabel={`${t('showMore')}: ${t('legalInfoTitle')}`}
      showLessAriaLabel={`${t('showLess')}: ${t('legalInfoTitle')}`}
    >
      <div className={styles.container}>
        {paragraphs.map((paragraph, index) => (
          <p key={`${index}-${paragraph}`} className={styles.text}>
            {paragraph}
          </p>
        ))}
      </div>
    </ShowMoreContent>
  );
};
